export const getExternalStore = () => require('./store');
